import {useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {ForgotPasswordData} from './types';

export function useForgotPasswordData() {
	const queryClient = useQueryClient();

	const setForgotPasswordData = (
		updater: Partial<ForgotPasswordData> | ((prev: ForgotPasswordData) => ForgotPasswordData),
	) => {
		const newData = queryClient.setQueryData(
			[QUERY_KEYS.FORGOT_PASSWORD_DATA],
			(prevData: ForgotPasswordData | undefined) => {
				let currentData = prevData;

				if (!currentData || Object.keys(currentData).length === 0) {
					try {
						const stored = localStorage.getItem(QUERY_KEYS.RESEND_TOKEN_DATA);
						if (stored) {
							currentData = JSON.parse(stored);
						}
					} catch {
						return {} as ForgotPasswordData;
					}
				}

				let result;
				if (typeof updater === 'function') {
					result = updater(currentData || ({} as ForgotPasswordData));
				} else {
					result = {...(currentData || {}), ...updater};
				}

				try {
					localStorage.setItem(QUERY_KEYS.RESEND_TOKEN_DATA, JSON.stringify(result));
				} catch {
					return result;
				}

				return result;
			},
		);
		return newData;
	};

	const data = queryClient.getQueryData<ForgotPasswordData>([QUERY_KEYS.FORGOT_PASSWORD_DATA]);

	const getForgotPasswordData = () => {
		if (data && Object.keys(data).length > 0) {
			return data;
		}

		try {
			const stored = localStorage.getItem(QUERY_KEYS.RESEND_TOKEN_DATA);
			if (stored) {
				return JSON.parse(stored);
			}
		} catch {
			return {} as ForgotPasswordData;
		}

		return {} as ForgotPasswordData;
	};

	return {
		data: getForgotPasswordData(),
		setForgotPasswordData,
	};
}
